import React, {Component} from 'react'
import Table from '../../tables/reactable/DefaultTable'
import StatusBadge from '../common/helpers/StatusBadge'

class ProductionList extends Component {
  constructor(props) {
    super(props)
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.state = {
      itemsPerPage: 10,
      openBtnVisible: true,
      openBtnLabel: 'View',
      search: '',
      filter: {
        Status: this.props.selectedFilter
      }
    }
    this.columns = [
      'Poster',
      'ProjectNumber',
      'ClientImageUrl',
      'OriginalTitle',
      'TypeAndFormat',
      'StatusModifiedDate',
      'Status',
      'ClientName'
    ]
    this.columnNames = [
      '',
      'Project number',
      'Client',
      'Original title',
      'Production type',
      'Status modified date',
      'Status',
      'ClientName'
    ]
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  onFilter(filter){
    this.setState({
      filter: filter
    })
  }

  render() {
    let items = this.props.items.map(item => {
      return Object.assign({}, item, {
        Status: (<StatusBadge status={item.Status.toLowerCase()} statusLabel={item.Status} />),
        Poster: item.PosterUrl ? (<img src={item.PosterUrl} style={{width: '50px'}} alt="" />) : (null),
        TypeAndFormat: item.ProductionType + ' - ' + item.TargetFormat,
        StatusModifiedDate: (<span statusmodifieddate={item.StatusModifiedDate}>{item.StatusModifiedDateAsString}</span>),
        ClientImageUrl: item.ClientImageUrl ? (<img src={item.ClientImageUrl} style={{borderRadius: '50%', width: '50px'}} alt="" />) : (<div title={item.ClientName} className="firstLetterCircle">{item.ClientName.charAt(0)}</div>)
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          searchable={this.props.searchable}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={this.props.filterable}
          filter={this.state.filter}
          onFilter={this.onFilter}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={this.state.openBtnVisible}
          openBtnLabel={this.state.openBtnLabel}
          openBtnHref="/productions/{NavigationParam}/overview"
          hiddenColumns={[
            'ClientName'
          ]}
          sortable={[
            'ProjectNumber',
            'OriginalTitle',
            'TypeAndFormat',
            {
                column: 'Status',
                sortFunction: function(a, b){
                  return a.props.statusLabel.localeCompare(b.props.statusLabel);
                }
            },
            {
                column: 'StatusModifiedDate',
                sortFunction: function(a, b){
                  return a.props.statusmodifieddate.localeCompare(b.props.statusmodifieddate);
                }
            },


          ]}
          defaultSort={{column: 'StatusModifiedDate', direction: 'desc'}}
        />
      </div>
    )
  }
}

export default ProductionList
